import { APISettings } from '../../config/ApiSettings';
import { BaseAPI } from './baseApi';
// const baseUrl = APISettings.apiUrl;
const baseUrl = new APISettings().getApiURL();

class ChapterFileAPI<ChapterFile> extends BaseAPI {
  // constructor() {}

  public getChapterFilesByChapterId: (chapterId: number) => Promise<ChapterFile[]> = async (
    chapterId: number
  ) => {
    return (await BaseAPI.axios.get(`${baseUrl}/ChapterImage/GetByChapterId/${chapterId}`)).data
      .output;
  };

  public createChapterFile: (chapterFile: ChapterFile) => Promise<ChapterFile> = async (
    chapterFile: ChapterFile
  ) => {
    return await BaseAPI.axios.post(`${baseUrl}/ChapterImage`, chapterFile);
  };

  public deleteById: (id: number) => Promise<ChapterFile> = async (id: number) => {
    return await BaseAPI.axios.delete(`${baseUrl}/ChapterImage/${id}`);
  };

  public deleteByBlobName: (blobName: string) => Promise<ChapterFile> = async (
    blobName: string
  ) => {
    return await BaseAPI.axios.delete(`${baseUrl}/ChapterImage/${blobName}`);
  };
}

export const chapterFileAPI = new ChapterFileAPI();
